module.exports = __webpack_public_path__ + "img/geocachinglogo.56e64c5f.jpg";